module.exports = __webpack_public_path__ + "img/es-pc-banner.6ec74857.png";